import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Providers } from "@/components/Providers";
import { RoquaLayout } from "@/components/RoquaLayout";
import { getEndpoint } from "@/lib/getEndpoint";
import { environment } from "@/lib/environment";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/$researchProjectId"
)({
  component: ResearchProjectLayout,
});

function ResearchProjectLayout() {
  const { organizationKey, dossierId, researchProjectId } = Route.useParams();
  const apiEndpoint = getEndpoint(environment);

  return (
    <Providers
      apiEndpoint={apiEndpoint}
      appsignalKey={import.meta.env.VITE_APPSIGNAL_PUSH_API_KEY ?? ""}
      organizationKey={organizationKey}
      dossierId={dossierId}
      researchProjectId={researchProjectId}
    >
      <RoquaLayout>
        <Outlet />
      </RoquaLayout>
    </Providers>
  );
}
